import React, { useState } from "react";
import TablePrueba from "../../pages/option/tablaTest";
import { formatPersonaDateTime } from "../../utils";

const DOCUMENT_TYPE_LABELS = {
  10: "CC",
  20: "NE",
  30: "PST",
  40: "NIT",
};

const hasValue = (value) =>
  value !== undefined && value !== null && value !== "";

const SummaryRow = ({ label, value, href }) => (
  <tr style={{ backgroundColor: "#fff" }}>
    <td className="field" style={{ backgroundColor: "#fff" }}>
      {label}
    </td>
    <td style={{ backgroundColor: "#fff" }}>
      {hasValue(value) ? (
        href ? (
          <a href={href} className="text-decoration-none">
            {value}
          </a>
        ) : (
          value
        )
      ) : (
        "-"
      )}
    </td>
  </tr>
);

const SUBTITLE_MAP = {
  "Como cliente": "Cliente en",
  "Como freelancer": "Freelance en",
  "Como beneficiario": "Beneficiario en",
  "Como responsable": "Responsable de",
};

const sectionSubtitle = (section) => {
  const n = section.data.length;
  const prefix = SUBTITLE_MAP[section.title] || section.title;
  return `${prefix} ${n} expediente${n !== 1 ? "s" : ""}`;
};

const RelatedFilesPanel = ({ visibleSections, relationsColumns }) => {
  const [activeTab, setActiveTab] = useState(0);

  if (visibleSections.length === 0) {
    return (
      <div className="text-center text-muted py-4">
        <i className="fa fa-folder-open fs-3 d-block mb-2 opacity-50"></i>
        Sin expedientes relacionados.
      </div>
    );
  }

  if (visibleSections.length === 1) {
    const section = visibleSections[0];
    return (
      <>
        <p className="mb-2" style={{ color: "#495057", fontSize: "0.95rem" }}>
          {sectionSubtitle(section)}
        </p>
        <TablePrueba
          data={section.data}
          columnsData={relationsColumns}
          pagination={true}
          pageSizeOptions={[10, 30, 50, 100, "all"]}
          height={section.data.length > 5 ? "30vh" : undefined}
        />
      </>
    );
  }

  return (
    <>
      <ul className="nav nav-pills" style={{ gap: "5px" }}>
        {visibleSections.map((section, idx) => (
          <li className="nav-item" key={section.title}>
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); setActiveTab(idx); }}
              className={`nav-link${activeTab === idx ? " active bg-black-400" : " bg-gray-300"}`}
            >
              {section.title}
              <span
                className="ms-1 badge rounded-pill bg-dark"
                style={{ fontSize: "0.7rem" }}
              >
                {section.data.length}
              </span>
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content panel p-3 rounded-0 rounded-bottom">
        {visibleSections.map((section, idx) => (
          <div
            className={`tab-pane fade${activeTab === idx ? " active show" : ""}`}
            key={section.title}
          >
            <p className="mb-2" style={{ color: "#495057", fontSize: "0.95rem" }}>
              {sectionSubtitle(section)}
            </p>
            <TablePrueba
              data={section.data}
              columnsData={relationsColumns}
              pagination={true}
              pageSizeOptions={[10, 30, 50, 100, "all"]}
              height={section.data.length > 5 ? "30vh" : undefined}
            />
          </div>
        ))}
      </div>
    </>
  );
};

const PersonaDetailView = ({ person, relatedSections, relationsColumns }) => {
  if (!person) return null;

  const documentLabel = DOCUMENT_TYPE_LABELS[person.document_type];
  const documentValue =
    documentLabel && person.document_id
      ? `${documentLabel} ${person.document_id}`
      : person.document_id || "-";

  const fullName = `${person.first_name || ""} ${person.last_name || ""}`.trim();
  const visibleSections = (relatedSections || []).filter(
    (section) => Array.isArray(section.data) && section.data.length > 0
  );

  return (
    <div className="row g-3 align-items-stretch">
      <div className="col-12 col-lg-5">
        <div className="card border-0 h-100 bg-transparent">
          <div className="card-body px-0 pb-0">
            <h3 className="mb-3 text-dark">{fullName || "-"}</h3>
            <hr className="mt-0 mb-4" />
            <div
              className="rounded-3 shadow-sm p-3"
              style={{ backgroundColor: "#fff" }}
            >
              <table
                className="table table-profile align-middle mb-0"
                ref={(el) =>
                  el &&
                  el.style.setProperty("background-color", "#fff", "important")
                }
              >
                <tbody style={{ backgroundColor: "#fff" }}>
                  <SummaryRow label="Documento" value={documentValue} />
                  <SummaryRow
                    label="Email"
                    value={person.email}
                    href={
                      hasValue(person.email)
                        ? `mailto:${person.email}`
                        : undefined
                    }
                  />
                  <SummaryRow
                    label="Tel personal"
                    value={person.phone_personal}
                    href={
                      hasValue(person.phone_personal)
                        ? `tel:${person.phone_personal}`
                        : undefined
                    }
                  />
                  <SummaryRow
                    label="Tel casa"
                    value={person.phone_home}
                    href={
                      hasValue(person.phone_home)
                        ? `tel:${person.phone_home}`
                        : undefined
                    }
                  />
                  <SummaryRow
                    label="Tel oficina"
                    value={person.phone_office}
                    href={
                      hasValue(person.phone_office)
                        ? `tel:${person.phone_office}`
                        : undefined
                    }
                  />
                  <SummaryRow label="Dirección" value={person.address} />
                  <SummaryRow label="Ciudad" value={person.city} />
                  <SummaryRow
                    label="Modificado"
                    value={formatPersonaDateTime(person.updated_at)}
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-7">
        <div className="card border-0 shadow-sm h-100 bg-white rounded-3">
          <div className="card-body d-flex flex-column h-100">
            <h3 className="mb-3 text-dark">Expedientes relacionados</h3>
            <hr className="mt-0 mb-4" />
            <RelatedFilesPanel
              visibleSections={visibleSections}
              relationsColumns={relationsColumns}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonaDetailView;
